import React from 'react';
import '../styles/tabSwitch.css';

/**
 * Унифицированный переключатель вкладок.
 * @param {Array}  tabs        — [{key, label, badge?}]
 * @param {string} activeTab   — key активной вкладки
 * @param {func}   onTabChange — (key) => void
 */
export default function TabSwitch({ tabs, activeTab, onTabChange }) {
  return (
    <div className="tab-switch-bar">
      {tabs.map(({ key, label, badge }) => (
        <button
          key={key}
          className={`tab-switch-btn${activeTab === key ? ' active' : ''}`}
          onClick={() => onTabChange(key)}
        >
          {label}
          {badge > 0 && <span className="tab-switch-badge">{badge}</span>}
        </button>
      ))}
    </div>
  );
}
